import React, { useEffect, useState, useContext, useRef, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Upload } from "@aws-sdk/lib-storage";
import { S3Client } from "@aws-sdk/client-s3";
import { FaFileDownload, FaFileExcel } from "react-icons/fa";
import { get, post } from "../Network/requests";
import { getUrl } from "../Network/urls";
import { tokenExpire, isValidFile } from "../Utils";
import toast from "react-hot-toast";
import Loader from "./UI/Loader";
import AppContext from "../Store/AppContext";
import NoDataFoundComponent from "./UI/NoDataFoundComponent";
import NotSubscribedMessageComponent from "./UI/NotSubscribedMessageComponent";
import DragAndDropUploadComponent from "./UI/DragAndDropUploadComponent";
import { RiFileUploadFill } from "react-icons/ri";
import FileDownloadModal from "./FileDownloadModal";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import { CellStyleModule } from "ag-grid-community";
import { ModuleRegistry, ClientSideRowModelModule } from "ag-grid-community";
import { IntegratedChartsModule } from "ag-grid-enterprise";
import { AgChartsEnterpriseModule } from "ag-charts-enterprise";
import { TbArrowsMinimize } from "react-icons/tb";
import { LuExpand } from "react-icons/lu";
import LinearLoader from "./UI/LinearLoader";
import DragAndDropUpload from "./UI/DragAndDropUpload";
import FileUploadComponent from "./UI/FileUploadComponent";
import RefreshAndFullscreenActions from "./UI/RefreshAndFullscreenActions";
import { MdOutlineDownload } from "react-icons/md";
import axios from "axios";
import GridLoader from "./UI/GridLoader";
ModuleRegistry.registerModules([
  ClientSideRowModelModule,
  IntegratedChartsModule.with(AgChartsEnterpriseModule),
  CellStyleModule,
]);

const UKRecordKeepingReportingComponent = ({ productCode, regulationCode }) => {
  const navigate = useNavigate();
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [showToast, setShowToast] = useState(true);
  const [filesData, setFilesData] = useState([]);
  const [columnData, setColumnData] = useState([]);
  const [fileDownload, setFileDownload] = useState("");
  const [fileName, setFileName] = useState("");
  const [fileUpload, setFileUpload] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const [isProductAccessible, setIsProductAccessible] = useState(false);
  const [isRegulationAccessible, setIsRegulationAccessible] = useState(false);
  const clientData = JSON.parse(localStorage.getItem("clientDetails"));
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [currentPlatform, setCurrentPlatform] = useState("");
  const [activeTab, setActiveTab] = useState("Input");
  const [file, setFile] = useState({});
  const [progress, setProgress] = useState(0);
  const [showProgressBar, setShowProgressBar] = useState(false);
  const controllerRef = useRef(null);
  const [showAbortIcon, setShowAbortIcon] = useState(false);
  const [isDragOver, setIsDragOver] = useState(false);
  const [debouncedIsDragOver, setDebouncedIsDragOver] = useState(false);
  const fileInputRef = useRef(null);

  const gridRef = useRef();
  const gridOptions = {
    pagination: true,
    paginationPageSize: 25,
    paginationPageSizeSelector: false,
  };
  const defaultColDef = useMemo(
    () => ({
      sortable: true,
      filter: true,
      // enableRowGroup: true,
      floatingFilter: false,
      editable: false,
      resizable: true,
      suppressMenu: true,
      suppressMovable: true,
    }),
    []
  );
  const operation = "files";
  // const productCode = "P004";
  // const regulationCode = "R001";
  const {
    secretAccessId,
    secretAccessKey,
    clientDetails,
    handleEncryptOtherParamsOfAPI,
    // encryptedClientValuesObj,
    inputBucketName,
    handleDecryptResponse,
    handleAPIEncryptValue,
    handleTextColorOfOutputFiles,
    handleEncryptValue,
    handleDecryptedValue,
    encryptedClientValuesObj,
  } = useContext(AppContext);
  const allowedRegulations = clientDetails.dataAccess[`${productCode}`] ?? [];
  const regulationCodeDefault = allowedRegulations[0] ?? null;

  const getStoredFiles = () => {
    // const clientName = clientData.clientName;
    // const bucketName = localStorage.getItem("REACT_APP_INPUT_BUCKET");
    // const uploadClientBucket = bucketName + clientName.toLowerCase() + '-01';
    // console.log(uploadClientBucket);
    setIsLoading(true);
    if (productCode in clientDetails.dataAccess) {
      // if (
      //   (allowedRegulations.includes(regulationCodeDefault)
      //   && regulationCode === null)
      //   || allowedRegulations.includes(regulationCode)
      // ) {
      setIsProductAccessible(true);
      setIsRegulationAccessible(true);
      const url = getUrl("fetch-file");
      // console.log("activeButton :", activeTab);
      const encryptedProductCode = handleEncryptValue(productCode);
      const encryptedRegulationCode = handleEncryptValue(regulationCode);
      const encryptedRole = handleEncryptValue(clientDetails.role);
      const encryptedClientId = handleEncryptValue(clientDetails.clientId);
      const encryptedSide = handleEncryptValue(activeTab);
      const encryptedOperation = handleEncryptValue(operation);
      // console.log(handleDecryptedValue(encryptedRole), '======',handleDecryptedValue(encryptedClientId));
      // const paramsObj = { productCode, regulationCode };
      // const encryptedParamsObj = handleEncryptOtherParamsOfAPI(paramsObj);
      // console.log(clientDetails);
      // console.log(
      //   productCode,
      //   regulationCode,
      //   clientDetails,
      //   activeTab,
      //   operation
      // );
      const data = {
        client_id: encryptedClientId,
        role: encryptedRole,
        product: encryptedProductCode,
        regulation: encryptedRegulationCode,
        operation: encryptedOperation,
        f_type: encryptedSide,
        email_id: clientDetails.email,
      };
      // console.log("data :", data);
      const regdataData = handleAPIEncryptValue(JSON.stringify(data));
      // get(
      //   `${url}?client_id=${clientData.clientId}&operation=${"files"}&side=${activeButton}&product=${productCode}&role=${clientData.role}`,
      //   true
      // )
      get(`${url}?regdata=${regdataData}`, true)
        .then((response) => {
          const {
            data: { encryptBody, statusCode, authData },
          } = response;
          setIsLoading(false);
          const finalArr = [];
          // console.log(finalArr);
          const iv = authData;
          const idToken = localStorage.getItem("userToken");
          const secretKey = idToken.slice(998, 1030);
          const body = handleDecryptResponse(
            encryptBody?.toString(),
            secretKey?.toString(),
            iv?.toString()
          );
          switch (statusCode) {
            case 200:
              // console.log(body, '--body');
              body.data.map((item) =>
                finalArr.push(
                  item.reduce(
                    (prev, next, index) => ({
                      ...prev,
                      [body.columns[index]]: next,
                    }),
                    {}
                  )
                )
              );
              setFilesData(finalArr);
              setColumnData([
                {
                  headerName: "SN",
                  field: "SN",
                  width: 120,
                  resizable: false,
                  suppressMovable: true,
                  cellStyle: { textAlign: "left" },
                  filter: "agTextColumnFilter",
                },
                {
                  headerName: "Records",
                  field: "Records",
                  width: 120,
                  resizable: false,
                  suppressMovable: true,
                  cellStyle: { textAlign: "left" },
                  filter: "agTextColumnFilter",
                },
                {
                  headerName: "File Name",
                  field: "FileName",
                  minWidth: 550,
                  resizable: true,
                  suppressMovable: true,
                  flex: 1,
                  cellStyle: { textAlign: "left" },
                  headerClass: "header-center",
                  cellClass: handleTextColorOfOutputFiles,
                  filter: "agTextColumnFilter",
                },
                {
                  headerName: "Type",
                  field: "Type",
                  width: 130,
                  resizable: false,
                  suppressMovable: true,
                  cellStyle: { textAlign: "left" },
                  filter: "agTextColumnFilter",
                  hide: activeTab === "Output",
                },
                {
                  headerName: "Source",
                  field: "Source",
                  width: 130,
                  resizable: false,
                  suppressMovable: true,
                  cellStyle: { textAlign: "left" },
                  filter: "agTextColumnFilter",
                  hide: activeTab === "Output",
                },
                {
                  headerName: "Date",
                  field: "Date",
                  width: 180,
                  resizable: false,
                  suppressMovable: true,
                  cellStyle: { textAlign: "left" },
                  filter: "agTextColumnFilter",
                },
                {
                  headerName: "Time",
                  field: "Time",
                  width: 120,
                  resizable: false,
                  suppressMovable: true,
                  cellStyle: { textAlign: "left" },
                  filter: "agTextColumnFilter",
                },
                {
                  headerName: "Download",
                  field: "Download",
                  resizable: false,
                  width: 120,
                  cellStyle: { textAlign: "left" },
                  suppressMovable: true,
                  filter: false,
                  sortable: false,
                  cellRenderer: (params) => (
                    <>
                      {/* <FaFileDownload
                        style={{
                          cursor: "pointer",
                          color: "#6c757d",
                        }}
                        onClick={() => handleFileDownload(params.data)}
                      /> */}
                      <MdOutlineDownload
                        onClick={() => handleFileDownload(params.data)}
                        className="text-black cursor-pointer"
                        size={23}
                      />
                    </>
                  ),
                },
                {
                  headerName: "Load Data",
                  field: "Load Data",
                  resizable: false,
                  width: 100,
                  cellStyle: { textAlign: "left" },
                  suppressMovable: true,
                  filter: false,
                  sortable: false,
                  cellRenderer: (params) => (
                    <>
                      {params.data.Load_Data === "True" ? (
                        <RiFileUploadFill
                          fontSize={14}
                          color="#6c757d"
                          cursor="pointer"
                          onClick={() => handleGridData(params.data.FileName)}
                        />
                      ) : (
                        <span style={{ color: "#6c757d", fontSize: 14 }}>
                          N/A
                        </span>
                      )}
                    </>
                  ),
                  hide: true,
                },
              ]);
              showToast && toast.success("Successfully fetched files.");
              setShowToast(false);
              break;
            case 400:
              toast.error("Error fetching the files.");
              break;
            default:
              toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
          }
        })
        .catch((error) => {
          toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
          tokenExpire(error.response, navigate);
          setIsLoading(false);
        });
    } else {
      setIsProductAccessible(false);
      setIsLoading(false);
    }
    // } else {
    //   setIsLoading(false);
    // }
  };

  const postFileUpload = () => {
    // setIsLoading(true);
    const url = getUrl("file-upload");
    const apiPayload = {
      httpMethod: "POST",
      parameters: {
        file: fileUpload,
        client_id: clientData.clientId,
        product: productCode,
        regulation: regulationCode,
        file_name: fileName,
      },
    };
    const fileData = JSON.stringify(apiPayload);
    // post(`${url}&product=${productCode}&regulation=${regulationCode}`, fileData, true)
    post(`${url}`, fileData, true)
      .then((response) => {
        const {
          data: { statusCode },
        } = response;
        // setIsLoading(false);
        switch (statusCode) {
          case 200:
            toast.success("File uploaded successfully.");
            setFileUpload("");
            getStoredFiles();
            break;
          case 400:
            toast.error("A server error occurred while uploading the file.");
            setFileUpload("");
            break;
          default:
            toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
            setFileUpload("");
        }
      })
      .catch((error) => {
        setFileUpload("");
        toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
        tokenExpire(error.response, navigate);
        // setIsLoading(false);
      });
  };

  const handleFileUpload = (e) => {
    let uploadFile = e[0];
    // if (regulationCode === null) { //----------------------------
    //   regulationCode = regulationCodeDefault;
    // }
    // console.log(uploadFile, '--uploadFile');
    if (isValidFile(productCode, uploadFile)) {
      setFileName(uploadFile.name);
      const cred = {
        accessKeyId: secretAccessId,
        secretAccessKey: secretAccessKey,
      };
      let regulationFolder;
      switch (productCode) {
        case "P004":
          regulationFolder = "input/";
          break;
        //   case "R002":
        //     regulationFolder = "Middleware_TrdR/";
        //     break;
        // case 'R003':
        //   regulationFolder = 'Middleware_EMIR/';
        //   break;
        // case 'R004':
        //   regulationFolder = 'Middleware_SFTR/';
        //   break;
        // case 'R007':
        //   regulationFolder = 'Middleware_EMIR_REFIT/';
        // break;
        default:
          toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
      }
      try {
        const parallelUploads3 = new Upload({
          client: new S3Client({ region: "eu-west-2", credentials: cred }),
          params: {
            Bucket: inputBucketName,
            Key: `${regulationFolder}${uploadFile.name}`,
            Body: uploadFile,
          },
          // queueSize: 4, // optional concurrency configuration
          partSize: 1024 * 1024 * 300, // optional size of each part, in bytes, at least 5MB
          leavePartsOnError: false,
        }); // optional manually handle dropped parts

        // parallelUploads3.on('httpUploadProgress', (progress) => {
        //   console.log(progress);
        // });
        // console.log(parallelUploads3);
        parallelUploads3.done();
        toast.success("File uploaded successfully.");
        getStoredFiles();
      } catch (error) {
        console.log(error);
      }
      // let reader = new FileReader();
      // reader.readAsDataURL(uploadFile);
      // setTimeout(() => {
      //   setFileUpload(reader.result.split(',')[1]);
      //   e.target.value = null;
      // }, 200);
      // } else {
    } else {
      toast.error("Invalid file to upload");
    }
  };

  const handleStopUploadOperation = () => {
    if (controllerRef.current) {
      try {
        controllerRef.current.abort();
        toast.info("Upload aborted", { autoClose: 1000 });
      } catch (e) {
        console.error("Abort failed:", e);
      }
    }
    setFile({});
    setProgress(0);
    setShowProgressBar(false);
    controllerRef.current = null;
    setShowAbortIcon(false);
  };

  const handleFileUploadToS3 = async (url, inputFile) => {
    const controller = new AbortController();
    controllerRef.current = controller;
    try {
      const res = await axios.put(url, inputFile, {
        signal: controller.signal,
        headers: {
          "Content-Type": file?.type,
        },
        onUploadProgress: (event) => {
          if (event.lengthComputable) {
            const fProgress = Math.round((event.loaded / event.total) * 100);
            // console.log('fProgress :', fProgress);
            setProgress(fProgress);
            if (fProgress < 100) {
              setShowAbortIcon(true);
            } else {
              setShowAbortIcon(false);
            }
          }
        },
      });
      switch (res.status) {
        case 200:
          setProgress(100);
          toast.success("File uploaded sucessfully");
          setTimeout(() => {
            getStoredFiles();
          }, 2000);
          setTimeout(() => {
            setShowProgressBar(false);
            setProgress(0);
            setFile({});
          }, 900); //Hide overlay for  short delay
          break;
        case 403:
          toast.error("Unauthorized. Please try again");
          setShowProgressBar(false);
          return;
        default:
          toast.error("Upload failed");
          setShowProgressBar(false);
          return;
      }
    } catch (error) {
      setShowProgressBar(false);
      if (error?.name === "CanceledError") {
        toast.error("File upload aborted");
      } else {
        toast.error(error?.message);
      }
    }
  };

  const handleFileUploadDemo = (uploadFile) => {
    if (uploadFile && isValidFile(productCode, uploadFile)) {
      setProgress(0);
      setFile(uploadFile);
      setShowProgressBar(true);
      setShowAbortIcon(false);
      let fileName = uploadFile.name?.replace(/\s+/g, "_");
      let regulationFolder;
      switch (productCode) {
        case "P004":
          regulationFolder = "input/";
          break;
        //   case "R002":
        //     regulationFolder = "Middleware_TrdR/";
        //     break;
        // case 'R003':
        //   regulationFolder = 'Middleware_EMIR/';
        //   break;
        // case 'R004':
        //   regulationFolder = 'Middleware_SFTR/';
        //   break;
        // case 'R007':
        //   regulationFolder = 'Middleware_EMIR_REFIT/';
        // break;
        default: {
          regulationFolder = "";
          toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
        }
      }
      if (fileName && regulationFolder) {
        try {
          const bucketName = "input";
          const key = `${regulationFolder}${fileName}`;
          const clientName = clientDetails?.clientName?.toLowerCase();
          const paramsObj = { key, bucketName, clientName };

          const encryptedParamsObj = handleEncryptOtherParamsOfAPI(paramsObj);
          const data = {
            key: encryptedParamsObj?.key,
            bucket_name: encryptedParamsObj?.bucketName,
            client_id: encryptedClientValuesObj.clientId,
            client_name: encryptedParamsObj.clientName,
            email_id: clientDetails?.email,
          };

          const regdataData = handleAPIEncryptValue(JSON.stringify(data));
          const url = getUrl("get-presigned-url");
          get(`${url}?regdata=${regdataData}`, true)
            .then((response) => {
              const {
                data: { encryptBody, statusCode, authData },
              } = response;
              const iv = authData;
              const idToken = localStorage.getItem("userToken");
              const secretKey = idToken.slice(998, 1030);
              const body = handleDecryptResponse(
                encryptBody.toString(),
                secretKey.toString(),
                iv.toString()
              );
              switch (statusCode) {
                case 200:
                  const presignedURL = body?.URL;
                  fileInputRef.current.value = "";
                  return presignedURL;
                case 400:
                  toast.error(body);
                  setShowProgressBar(false);
                  return null;
                case 401:
                  toast.error(body);
                  setShowProgressBar(false);
                  tokenExpire(statusCode, navigate); // logout
                  return null;
                default:
                  toast.error("Unexpected error");
                  setShowProgressBar(false);
                  return null;
              }
            })
            .then((presignedURL) => {
              if (presignedURL) {
                setShowAbortIcon(true);
                handleFileUploadToS3(presignedURL, uploadFile, true);
              }
            });
        } catch (error) {
          console.log("errror :", error);
          toast.error(process.env.REACT_APP_DEFAULT_ERROR_MESSAGE);
          tokenExpire(error, navigate);
          setShowProgressBar(false);
        }
      }
    } else {
      toast.error("File format is not accepted");
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    }
  };
  const handleTabs = (changedTab) => {
    setActiveTab(changedTab);
  };

  useEffect(() => {
    const timeout = setTimeout(() => {
      setDebouncedIsDragOver(isDragOver);
    }, 200);

    return () => clearTimeout(timeout);
  }, [isDragOver]);

  const handleDragOver = (e) => {
    const hasFiles = Array.from(e.dataTransfer.types).includes("Files");
    if (hasFiles) {
      e.preventDefault();
      if (!isDragOver) setIsDragOver(true);
    }
  };

  const handleDragLeave = (e) => {
    const hasFiles = Array.from(e.dataTransfer.types).includes("Files");
    if (hasFiles) {
      e.preventDefault();
      setIsDragOver(false);
    }
  };

  const handleDrop = (e) => {
    const hasFiles = Array.from(e.dataTransfer.types).includes("Files");
    if (hasFiles) {
      e.preventDefault();
      handleFileUploadDemo(e.dataTransfer.files[0]);
      setIsDragOver(false);
    }
  };

  const handleGridData = (e) => {
    if (e.startsWith(`NCA_Demo_FCA_Accuracy_MIFIDII_RK_TxnR_`, 0)) {
      localStorage.setItem("txnrFileName", e);
      toast.success("File loaded successfully in Transactions.");
    } else if (e.startsWith(`NCA_Demo_FCA_Accuracy_MIFIDII_RK_CO_`, 0)) {
      localStorage.setItem("ordFileName", e);
      toast.success("File loaded successfully in Orders.");
    } else if (e.startsWith(`NCA_Demo_FCA_Accuracy_MIFIDII_RK_Venues_`, 0)) {
      localStorage.setItem("venueFileName", e);
      toast.success("File loaded successfully in Venue.");
    } else {
      localStorage.setItem("coFileName", e);
      toast.success("File loaded successfully in Client Orders.");
    }
  };

  const handleFileDownload = (obj) => {
    setFileDownload(obj.FileName);
    setShowDownloadModal(!showDownloadModal);
  };

  useEffect(() => {
    if (fileUpload) {
      postFileUpload();
    }
  }, [fileUpload]);

  useEffect(() => {
    getStoredFiles();
  }, [activeTab]);

  return (
    <>
      <main className="middle_section dashboard_middle">
        <div
          className="container-fluid position-relative"
          onDragOver={activeTab === "Input" ? handleDragOver : null}
          onDrop={activeTab === "Input" ? handleDrop : null}
          onDragLeave={activeTab === "Input" ? handleDragLeave : null}
        >
          {isProductAccessible ? (
            <>
              {/* <div className="dashboard_header">
                    {activeButton === "Input" &&
                      clientDetails?.inputAccess === "True" && (
                        <DragAndDropUploadComponent
                          width="675px"
                          onUpload={handleFileUpload}
                        />
                      )}
                    <div
                      className={
                        isRegulationAccessible
                          ? "form-input-radio"
                          : "form-input-radio disable-tag"
                      }
                    >
                      <div
                        className={
                          isRegulationAccessible
                            ? "form-check header-button"
                            : "form-check header-button disable-anchor"
                        }
                      >
                        <input
                          className="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id="flexRadioDefault1"
                          onChange={handleButtonChange}
                          checked={activeButton === "Input"}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault1"
                        >
                          Input Files
                        </label>
                      </div>
                      <div
                        className={
                          isRegulationAccessible
                            ? "form-check header-button"
                            : "form-check header-button disable-anchor"
                        }
                      >
                        <input
                          className="form-check-input"
                          type="radio"
                          name="flexRadioDefault"
                          id="flexRadioDefault2"
                          onChange={handleButtonChange}
                          checked={activeButton === "Output"}
                        />
                        <label
                          className="form-check-label"
                          htmlFor="flexRadioDefault2"
                        >
                          Output Files
                        </label>
                      </div>
                    </div>
                    <div
                      className={
                        isRegulationAccessible &&
                        activeButton === "Input" &&
                        clientDetails?.inputAccess === "True"
                          ? "dash_btn"
                          : "disable-tag"
                      }
                      style={{ maxWidth: "160px", marginRight: "10px" }}
                    >
                      <input
                        type="file"
                        className={
                          isRegulationAccessible &&
                          activeButton === "Input" &&
                          clientDetails?.inputAccess === "True"
                            ? "dash_btn"
                            : "dash_btn disable-anchor"
                        }
                        onChange={(e) => handleFileUpload(e.target.files)}
                        accept="application/xml, text/csv, application/vnd.ms-excel , application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                      />
                    </div>
                    <div
                      className={
                        isRegulationAccessible ? "dash_btn" : "dash_btn disable-tag"
                      }
                      style={{ maxWidth: "160px" }}
                    >
                      <Link
                        to="#"
                        className={
                          isRegulationAccessible
                            ? "dash_btn"
                            : "dash_btn disable-anchor"
                        }
                        onClick={() => getStoredFiles()}
                      >
                        Refresh
                      </Link>
                    </div>
                  </div> */}
              <div
                className={`dashboard_inner pt-0 ${
                  isFullscreen ? "fullscreen-grid" : "mt-0"
                }`}
              >
                <DragAndDropUpload debouncedIsDragOver={debouncedIsDragOver} />
                <div className="d-flex align-items-center justify-content-between">
                  <FileUploadComponent
                    accept="application/xml, text/csv, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    showTabs={true}
                    handleTabs={handleTabs}
                    activeTab={activeTab}
                    handleStopUploadOperation={handleStopUploadOperation}
                    fileInputRef={fileInputRef}
                    showProgressbar={showProgressBar}
                    progress={progress}
                    file={file}
                    onUpload={handleFileUploadDemo}
                    showAbortIcon={showAbortIcon}
                  />
                  <div className="d-flex justify-content-end">
                    <RefreshAndFullscreenActions
                      isFullscreen={isFullscreen}
                      onToggleFullscreen={() =>
                        setIsFullscreen((fullScreen) => !fullScreen)
                      }
                      onRefresh={getStoredFiles}
                      iconDisabled={isLoading}
                    />
                  </div>
                </div>
                {/* <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-center gap-3 gridIcons">
                      {isFullscreen ? (
                        <TbArrowsMinimize
                          fontWeight={700}
                          className="cursor-pointer"
                          style={{ color: "black", fontSize: "20px" }}
                          onClick={() => setIsFullscreen(false)}
                        />
                      ) : (
                        <LuExpand
                          fontWeight={700}
                          style={{ color: "black", fontSize: "20px" }}
                          className="cursor-pointer"
                          onClick={() => setIsFullscreen(true)}
                        />
                      )}
                    </div>
                  </div> */}
                <div className="rx_table_wrapper table-responsive padding-fix">
                  <div
                    className="ag-theme-alpine ag-theme-quartz"
                    style={{
                      height: isFullscreen ? "calc(100vh - 60px)" : "80vh",
                      width: "100%",
                    }}
                  >
                    {isLoading ? (
                      <GridLoader />
                    ) : (
                      <AgGridReact
                        theme="legacy"
                        ref={gridRef}
                        // rowGroupPanelShow="always"
                        rowData={filesData}
                        columnDefs={columnData}
                        animateRows
                        rowSelection="multiple"
                        enableCellTextSelection
                        defaultColDef={defaultColDef}
                        enableBrowserTooltips={true}
                        gridOptions={gridOptions}
                        tooltipShowDelay={0}
                        cellSelection={true}
                        enableCharts
                      />
                    )}
                  </div>
                </div>
              </div>
            </>
          ) : (
            <NotSubscribedMessageComponent />
          )}
        </div>
      </main>

      {showDownloadModal && (
        <FileDownloadModal
          show={showDownloadModal}
          onHide={() => setShowDownloadModal(false)}
          onDownload={fileDownload}
          operation={operation}
          source={activeTab} // input || output || fileStorge ||referenceData
          productCode={productCode}
          regulationCode={regulationCode}
          // downloadText="Do you want to download the file?"
          // showDownloadModal
        />
      )}
    </>
  );
};

export default UKRecordKeepingReportingComponent;
